import Layout from "../../components/Layout/Layout";
import { FAQs } from "../../helpers/constants";

function FAQ(props) {
  const questions = FAQs(props);
  return (
    <Layout {...props}>
      <div className="row gutters">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ms-2 mt-2">
          <h4>Frequently Asked Questions</h4>
          <div className="accordion accordion-flush mt-4" id="accordion">
            {questions.map((question, index) => (
              <div key={`question${index}`} className="accordion-item">
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false"
                    aria-controls={`collapse${index}`}
                  >
                    {question.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">{question.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default FAQ;
